
// possibleAnswers: string separated by "," or array
// Does not differentiate upper and lower case.
export const isValidAnswer = (answer, possibleAnswers) => {
  answer = answer?.trim().toUpperCase();
  if(!possibleAnswers)
    return false;
  
  var answers;
  if(typeof possibleAnswers == 'string') {
    answers = possibleAnswers.split(",");
  }
  else
    answers = possibleAnswers;

  for(var i = 0; i < answers.length; i++) {
    answers[i] = answers[i].trim().toUpperCase();
  }
  // console.log('isValid ',answers.includes(answer), answers, answer)
  return answers.includes(answer);
}

export const isValidMulti = (answers, enigma) => {
  if(!answers) {
    return {...enigma, status: 'INVALID'}
  }
  if(enigma.fields) {
    var isValid = true;
    var fields = enigma.fields.map(field => {
      var isFieldValid = isValidAnswer(answers[field.fieldId], field.answer);
      if(!isFieldValid)
        isValid = false;
      return {...field, status:isFieldValid ? 'VALID' : 'INVALID'}
    })
    return {...enigma, fields:fields, status:isValid ? 'VALID' : 'INVALID'};
  }
  if(typeof answers == 'string')
    return {...enigma, status:isValidAnswer(answers, enigma.answer) ? 'VALID' : 'INVALID'}
  else
    return {...enigma, status:isValidAnswer(answers[0], enigma.answer) ? 'VALID' : 'INVALID'}
}